import { render, staticRenderFns } from "./Filters.vue?vue&type=template&id=28bead4f&scoped=true&"
import script from "./Filters.vue?vue&type=script&lang=js&"
export * from "./Filters.vue?vue&type=script&lang=js&"
import style0 from "./Filters.vue?vue&type=style&index=0&id=28bead4f&prod&scoped=true&lang=scss&"
import style1 from "./Filters.vue?vue&type=style&index=1&id=28bead4f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bead4f",
  null
  
)

export default component.exports